export const START_DATE = "startDate";
export const END_DATE = 'endDate';

export const HORIZONTAL_ORIENTATION = 'horizontal';